export default {
    // --------Title--------
    logisticType: 'Logistic Type',
    logisticInfo: 'Logistic Info',
    document: 'Document',
    basicInformationAboutTheDocument: 'Basic information about the document',
    relatedWarehouseLocationToProcess: 'Related warehouse location to process',

    // --------DIalog-------
    searchTripDocuments: 'Search Trip Documents',
    documentType: 'Document Type',
    searchDocumentNo: 'Search Document No.',
    profileName: 'Profile Name',
    confirmSelection: 'Confirm Selection',
    reset: 'Reset',
    noRecordsAvailable: 'No records available',

    // --------MUI--------
    label: 'Label',
    vehiclePlateNo: 'Vehicle Plate No',            
    vehicleModel: 'Vehicle Model',            
    vehicleBrand: 'Vehicle Brand',    
    
    date: 'Date',
    driver: 'Driver',
    logistic: 'Logistic',
    completion: 'Completion',
    completed: 'Completed',
    incomplete: 'Incomplete',
    pending: 'Pending',
    referenceNo: 'Reference No.',
    locationFrom: 'Location From',
    documentNumber: 'Document Number',
    logistics: 'Logistics',

    confirmedAt: 'Confirmed at',
    markAsConfirm: 'Mark as Confirm',
    yesIveConfirmed: `Yes, I've Confirmed`,

};